import React from 'react';
import { Icons } from '../../Icon.jsx';

const BindingList = ({ comp, searchQuery, onSearchChange, onSelectNode, onUpdateBindings, onUnbind }) => {
    const bindings = (comp.props.bindings) || [];
    const filteredBindings = bindings.filter(b => 
        b.externalKey.toLowerCase().includes(searchQuery.toLowerCase()) || 
        b.property.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="flex flex-col gap-1 mt-2">
            <div className="text-[10px] font-semibold text-gray-400 mb-1 px-1">Exported Properties</div>
            
            {/* Search Box */}
            <div className="flex items-center gap-1 border border-slate-200 rounded px-1 mb-1">
                <Icons.Search className="w-2.5 h-2.5 text-gray-400"/>
                <input 
                    className="flex-1 min-w-0 bg-transparent text-xs py-1 outline-none" 
                    placeholder="Search bindings..." 
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
                {searchQuery && <button onClick={() => onSearchChange('')}><Icons.Remove className="w-2.5 h-2.5 text-gray-400"/></button>}
            </div>

            {bindings.length === 0 && <div className="text-[10px] text-gray-400 italic px-1">No bindings. Click property labels to bind.</div>}
            {filteredBindings.map((b, idx) => (
                <div key={b.id} className="flex items-center gap-2 bg-slate-100 rounded px-2 py-1 border border-slate-200">
                    <div className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0" />
                    <input 
                        className="flex-1 bg-transparent text-xs font-mono outline-none min-w-0 text-slate-700" 
                        value={b.externalKey}
                        onChange={(e) => {
                            const newB = bindings.map(existing => existing.id === b.id ? { ...existing, externalKey: e.target.value } : existing);
                            onUpdateBindings(comp.id, 'bindings', newB);
                        }}
                    />
                    <div 
                        className="text-[9px] text-gray-400 truncate max-w-[80px] cursor-pointer hover:text-blue-500 hover:underline" 
                        title={`Go to ${b.property}`}
                        onClick={() => onSelectNode([b.nodeId])}
                    >
                        {b.property}
                    </div>
                    <button onClick={() => onUnbind(b.id)} className="text-gray-400 hover:text-red-500"><Icons.Remove className="w-2.5 h-2.5"/></button>
                </div>
            ))}
        </div>
    );
};

export default BindingList;
